import "../../css/pages/capabilitiesDetail.scss";
import Tabs from "../modules/tabs";
import BasePage from "./base";
import { setScrollLink } from "../modules/scrollTo";
import { adjustImageSize } from "../modules/calloutText";
import boxedItem from "../modules/boxedItem";
import sectionNav from "../modules/sectionNav";
import diamons from "../../js/modules/diamons";
import popUpButton from "../modules/popUpButton";
import accordionList from "../modules/accordionList";

class CapabilitiesDetailPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        new Tabs();
    }

    onReady() {
        super.onReady();
        setScrollLink(".pageHero__homeButton");
        adjustImageSize();
        sectionNav.init();
        diamons.init();
        popUpButton.init();
        accordionList.init();
    }

    onLoad() {
        super.onLoad();
        boxedItem.setMobileView();
    }
}

new CapabilitiesDetailPage();
